import {Component, OnInit} from '@angular/core';
import {MatDialogRef, MatDialog} from '@angular/material/dialog';
import {TermsOfUseModalComponent} from '../terms-of-use-modal/terms-of-use-modal.component';
import {LegalTermsService} from '../../../../../../core/services/legal-terms.service';
import {marked} from 'marked';

@Component({
  selector: 'app-privacy-notice-modal',
  templateUrl: './privacy-notice-modal.component.html',
  styleUrls: ['./privacy-notice-modal.component.scss'],
})
export class PrivacyNoticeModalComponent implements OnInit {
  content: string | null = null;
  isLoading: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<PrivacyNoticeModalComponent>,
    public dialog: MatDialog,
    private legalTermsService: LegalTermsService
  ) {
  }

  async ngOnInit() {
    this.isLoading = true;
    const rawContent = await this.legalTermsService.getPrivacyPolicy();
    if (rawContent) {
      this.content = await marked.parse(rawContent);
    } else {
      this.content = null;
    }
    this.isLoading = false;
  }

  close(): void {
    this.dialogRef.close();
  }

  openTerms(): void {
    this.dialogRef.close();
    this.dialog.open(TermsOfUseModalComponent, {
      maxWidth: '95vw',
      maxHeight: '90vh',
      width: '800px',
      panelClass: 'responsive-modal'
    });
  }
}
